import React, { useEffect, useMemo, useState } from 'react';
import { API_BASE_URL } from '../config/api.js';
import { content, serverIp } from '../config/site.js';

export default function Status({ lang }) {
  const t = content[lang].status;
  const [serverStatus, setServerStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE_URL}/server-status.php`)
      .then((response) => response.json())
      .then((data) => {
        if (!cancelled && data?.success) {
          setServerStatus(data.status);
        }
      })
      .catch(() => {
        if (!cancelled) setServerStatus(null);
      });

    const timer = window.setInterval(() => {
      fetch(`${API_BASE_URL}/server-status.php`)
        .then((response) => response.json())
        .then((data) => {
          if (!cancelled && data?.success) {
            setServerStatus(data.status);
          }
        })
        .catch(() => {});
    }, 30000);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  const stats = useMemo(() => {
    const nextStats = t.stats.map((item) => ({ ...item }));
    const onlineIndex = nextStats.findIndex((item) => /online/i.test(item.label) || /Player Online/i.test(item.label));

    if (onlineIndex >= 0 && serverStatus !== null) {
      const players = Number(serverStatus?.players ?? 0);
      const maxPlayers = Number(serverStatus?.maxplayers || serverStatus?.maxPlayers || 200);
      nextStats[onlineIndex].value = `${players}/${maxPlayers}`;
      nextStats[onlineIndex].detail = serverStatus?.source === 'sftp_json'
        ? 'Data player online dibaca dari discord_status.json via SFTP.'
        : `${serverStatus.address || serverIp} sedang online.`;
    }

    const registeredIndex = nextStats.findIndex((item) => /terdaftar/i.test(item.label) || /registered/i.test(item.label));
    if (registeredIndex >= 0 && serverStatus?.registered_accounts !== undefined) {
      const totalAccounts = Number(serverStatus.registered_accounts || 0);
      nextStats[registeredIndex].value = `${totalAccounts.toLocaleString('id-ID')}+`;
      nextStats[registeredIndex].detail = 'Total akun UCP yang sudah terdaftar pada sistem.';
    }

    return nextStats;
  }, [t.stats, serverStatus]);

  return (
    <section className="section reveal" id="status">
      <div className="section-heading centered">
        <span className="section-label">{t.label}</span>
        <h2>{t.title}</h2>
        <p>{t.text}</p>
      </div>

      <div className="stats-grid compact-stats">
        {stats.map((item) => (
          <article className="stat-box surface reveal reveal-child" key={item.label}>
            <strong>{item.value}</strong>
            <span>{item.label}</span>
            <p>{item.detail}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
